import React from "react";
import { Link } from "react-router-dom";
import { formatAfn, getProductPrice, getImageUrl } from "../lib/api";
import ImageWithSkeleton from "./ImageWithSkeleton";

const categoryLabels = {
  honey: "عسل",
  saffron: "زعفران",
  dried_fruit: "میوه خشک",
  other: "متفرقه",
};

export default function ProductCard({ product, index = 0 }) {
  const imgUrl = getImageUrl(product.images?.[0]) ||
    "https://images.unsplash.com/photo-1556316828-60a9fe5343ae?w=1000";
  const thumbUrl = getImageUrl(product.images?.[0], "thumb") || imgUrl;
  return (
    <Link
      to={`/products/${product.slug}`}
      className="group block bg-white rounded-3xl overflow-hidden border border-stone-200 product-card-hover animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-cream-100 relative">
        <ImageWithSkeleton
          src={imgUrl}
          thumb={thumbUrl}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          decoding="async"
        />
        {product.featured && (
          <span className="absolute top-4 right-4 bg-amber-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
            ویژه
          </span>
        )}
        {!product.in_stock && (
          <span className="absolute top-4 left-4 bg-stone-800 text-white text-xs font-semibold px-3 py-1 rounded-full">
            ناموجود
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-amber-700 bg-amber-50 px-2.5 py-1 rounded-full font-medium">
            {categoryLabels[product.category] || product.category}
          </span>
          {product.weight && (
            <span className="text-xs text-stone-500 persian-numerals">
              {product.weight}
            </span>
          )}
        </div>
        <h3 className="text-lg font-bold text-stone-900 mb-1 line-clamp-1 group-hover:text-amber-700 transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-stone-600 line-clamp-2 mb-3 leading-relaxed min-h-[40px]">
          {product.short_description}
        </p>
        <div className="flex items-center justify-between pt-2 border-t border-stone-100">
          {getProductPrice(product) ? (
            <span className="font-bold text-amber-700 persian-numerals">
              {formatAfn(getProductPrice(product))}
            </span>
          ) : (
            <span className="text-sm text-stone-500">تماس بگیرید</span>
          )}
          <span className="text-sm text-amber-700 group-hover:translate-x-1 transition-transform">
            مشاهده ←
          </span>
        </div>
      </div>
    </Link>
  );
}
